module.exports = __webpack_public_path__ + "assets/img/visualization_1.9a1819fb.png";